export const DIAPO_ENHANCEMENT_MAIN_TITLE = 'Enrichir le diaporama';
export const TAGS_DIALOG_TOOLTIP_TEXT =
  "Pour la prise en compte de vos modifications, n'oubliez pas de sauvegarder votre diaporama";
export const TAGS_DIALOG_CLOSE_BUTTON_TEXT = 'Valider et fermer';
